// // // // import Modal from "@mui/material/Modal";
// // // // import React, { useState, useEffect } from "react";
// // // // import axiosClient from "../axiosClient";
// // // // import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
// // // // import EventAvailableOutlinedIcon from "@mui/icons-material/EventAvailableOutlined";
// // // // import {
// // // //   Typography,
// // // //   TextField,
// // // //   Button,
// // // //   Box,
// // // //   FormControl,
// // // //   InputLabel,
// // // //   Select,
// // // //   MenuItem,
// // // //   ListItem,
// // // //   ListItemText,
// // // //   IconButton,
// // // // } from "@mui/material";
// // // // import { useStateContext } from "../context/ContextProvider";
// // // // import { useTranslation } from "react-i18next";
// // // // import CalendarCheckbox from "./SmallCalendar";

// // // // const style = {
// // // //   position: "absolute",
// // // //   top: "50%",
// // // //   left: "50%",
// // // //   transform: "translate(-50%, -50%)",
// // // //   width: { xs: "90vw", sm: "80vw", md: 800 },
// // // //   maxHeight: "90vh",
// // // //   overflowY: "auto",
// // // //   bgcolor: "background.paper",
// // // //   border: "2px solid #000",
// // // //   boxShadow: 24,
// // // //   p: { xs: 2, sm: 4 },
// // // //   borderRadius: 2,
// // // // };

// // // // export default function AppointmentEditModal({
// // // //   id,
// // // //   open,
// // // //   handleClose,
// // // //   getAppointment,
// // // //   isDelete = false,
// // // // }) {
// // // //   const [staffUsers, setStaffUsers] = useState([]);
// // // //   const [clientUsers, setClientUsers] = useState([]);
// // // //   const [appointment, setAppointment] = useState({
// // // //     appointment_date: "",
// // // //     appointment_start: "",
// // // //     appointment_end: "",
// // // //     client_id: "",
// // // //     staff_id: "",
// // // //     comments: [],
// // // //     earlier_date: "",
// // // //   });
// // // //   const [selectedClient, setSelectedClient] = useState("");
// // // //   const [selectedStaff, setSelectedStaff] = useState("");
// // // //   const [selectedDateCalendar, setSelectedDateCalendar] = useState(null);
// // // //   const [isLoading, setIsLoading] = useState(true);
// // // //   const [showCalendar, setShowCalendar] = useState(false);

// // // //   const { t } = useTranslation();
// // // //   const { user } = useStateContext();

// // // //   const handleChange = (e) => {
// // // //     setAppointment({
// // // //       ...appointment,
// // // //       [e.target.name]: e.target.value,
// // // //     });
// // // //   };

// // // //   useEffect(() => {
// // // //     if (user?.user_role === "ADMIN" || user?.user_role === "STAFF") {
// // // //       Promise.all([
// // // //         axiosClient.get("api/staff-users/"),
// // // //         axiosClient.get("api/client-users/"),
// // // //       ])
// // // //         .then(([staffRes, clientRes]) => {
// // // //           setStaffUsers(staffRes?.data);
// // // //           setClientUsers(clientRes?.data);
// // // //         })
// // // //         .catch((error) => {
// // // //           console.log(error);
// // // //         });
// // // //     }
// // // //     // eslint-disable-next-line
// // // //   }, []);

// // // //   useEffect(() => {
// // // //     if (id && open) {
// // // //       const fetchData = async () => {
// // // //         try {
// // // //           setIsLoading(true);
// // // //           const getAppointmentResponse = await axiosClient.get(
// // // //             `api/appointment/${id}/`
// // // //           );
// // // //           console.log(getAppointmentResponse?.data);
// // // //           const getAppointmentComments = await axiosClient.get(
// // // //             `api/comments/${id}/`
// // // //           );

// // // //           setAppointment({
// // // //             ...getAppointmentResponse?.data,
// // // //             appointment_date: getAppointmentResponse?.data?.appointment_date || "",
// // // //             earlier_date: getAppointmentResponse?.data?.earlier_date || "",
// // // //             comments: getAppointmentComments.data,
// // // //           });
// // // //           setSelectedClient(getAppointmentResponse?.data?.client_id);
// // // //           setSelectedStaff(getAppointmentResponse?.data?.staff_id);
// // // //           setSelectedDateCalendar(
// // // //             getAppointmentResponse?.data?.earlier_date
// // // //               ? new Date(getAppointmentResponse?.data?.earlier_date)
// // // //               : null
// // // //           );
// // // //         } catch (error) {
// // // //           console.error("Error fetching appointment:", error);
// // // //         } finally {
// // // //           setIsLoading(false);
// // // //         }
// // // //       };
// // // //       fetchData();
// // // //     }
// // // //   }, [open, id]);

// // // //   // useEffect(() => {
// // // //   //     if (selectedStaff) {
// // // //   //         const filteredData = clientUsers.filter(user => user.assigned_staff === selectedStaff);
// // // //   //         setClientUsers(filteredData);
// // // //   //     }
// // // //   // }, [selectedStaff])

// // // //   // Synchronize selectedDateCalendar with appointment.earlier_date
// // // //   useEffect(() => {
// // // //     if (selectedDateCalendar) {
// // // //       setAppointment((prev) => ({
// // // //         ...prev,
// // // //         earlier_date: formatDate(selectedDateCalendar),
// // // //       }));
// // // //     } else {
// // // //       setAppointment((prev) => ({
// // // //         ...prev,
// // // //         earlier_date: "",
// // // //       }));
// // // //     }
// // // //   }, [selectedDateCalendar]);

// // // //   const handleDelete = () => {
// // // //     axiosClient
// // // //       .delete(`api/appointment/${id}/`)
// // // //       .then((res) => {
// // // //         getAppointment();
// // // //         handleClose();
// // // //       })
// // // //       .catch((error) => {
// // // //         console.error("Error deleting appointment:", error);
// // // //       });
// // // //   };

// // // //   const formatDate = (date) => {
// // // //     if (!date) return "";
// // // //     const year = date.getFullYear();
// // // //     const month = String(date.getMonth() + 1).padStart(2, "0");
// // // //     const day = String(date.getDate()).padStart(2, "0");
// // // //     return `${year}-${month}-${day}`;
// // // //   };

// // // //   const handleSubmit = (e) => {
// // // //     e.preventDefault();

// // // //     // Validate required fields
// // // //     if (!selectedClient && !appointment?.client_id) {
// // // //       console.error("Error: Client ID is required");
// // // //       alert(t("Client ID is required"));
// // // //       return;
// // // //     }
// // // //     if (!selectedStaff && !appointment?.staff_id) {
// // // //       console.error("Error: Staff ID is required");
// // // //       alert(t("Staff ID is required"));
// // // //       return;
// // // //     }
// // // //     if (!appointment?.appointment_date) {
// // // //       console.error("Error: Appointment date is required");
// // // //       alert(t("Appointment date is required"));
// // // //       return;
// // // //     }
// // // //     if (!appointment?.appointment_start) {
// // // //       console.error("Error: Appointment start time is required");
// // // //       alert(t("Appointment start time is required"));
// // // //       return;
// // // //     }
// // // //     if (!appointment?.appointment_end) {
// // // //       console.error("Error: Appointment end time is required");
// // // //       alert(t("Appointment end time is required"));
// // // //       return;
// // // //     }

// // // //     const updatedAppointment = {
// // // //       ...appointment,
// // // //       client_id: selectedClient ? selectedClient : appointment?.client_id,
// // // //       staff_id: selectedStaff ? selectedStaff : appointment?.staff_id,
// // // //       appointment_start_time_str:
// // // //         appointment?.appointment_start?.length === 5
// // // //           ? `${appointment?.appointment_start}:00`
// // // //           : appointment?.appointment_start,
// // // //       appointment_finish_time_str:
// // // //         appointment?.appointment_end?.length === 5
// // // //           ? `${appointment?.appointment_end}:00`
// // // //           : appointment?.appointment_end,
// // // //       earlier_date: selectedDateCalendar ? formatDate(selectedDateCalendar) : "",
// // // //     };

// // // //     console.log("Updated Appointment:", updatedAppointment);

// // // //     axiosClient
// // // //       .put(`api/appointment-edit/${id}/`, updatedAppointment)
// // // //       .then((res) => {
// // // //         getAppointment();
// // // //         handleClose();
// // // //       })
// // // //       .catch((error) => {
// // // //         console.log(error);
// // // //       });
// // // //   };

// // // //   const handleModalClose = (event, reason) => {
// // // //     // Prevent closing on backdrop click or Escape key press
// // // //     if (reason === "backdropClick" || reason === "escapeKeyDown") {
// // // //       return;
// // // //     }
// // // //     setAppointment({
// // // //       appointment_date: "",
// // // //       appointment_start: "",
// // // //       appointment_end: "",
// // // //       client_id: "",
// // // //       staff_id: "",
// // // //       comments: [],
// // // //       earlier_date: "",
// // // //     });
// // // //     setSelectedClient("");
// // // //     setSelectedStaff("");
// // // //     setSelectedDateCalendar(null);
// // // //     setIsLoading(true);
// // // //     setShowCalendar(false);
// // // //     handleClose();
// // // //   };

// // // //   const handleCalendarOpen = () => {
// // // //     setShowCalendar(true);
// // // //   };

// // // //   return (
// // // //     <Modal
// // // //       open={open}
// // // //       onClose={handleModalClose}
// // // //       aria-labelledby="modal-modal-title"
// // // //       aria-describedby="modal-modal-description"
// // // //       disableEscapeKeyDown
// // // //     >
// // // //       <Box sx={style}>
// // // //         {isLoading ? (
// // // //           <Typography>Loading...</Typography>
// // // //         ) : (
// // // //           <>
// // // //             <Box
// // // //               sx={{
// // // //                 display: "flex",
// // // //                 justifyContent: "space-between",
// // // //                 alignItems: "center",
// // // //                 mb: 1,
// // // //               }}
// // // //             >
// // // //               <Typography
// // // //                 id="modal-modal-title"
// // // //                 sx={{ fontSize: { xs: "16px", sm: "18px" }, fontWeight: "500" }}
// // // //                 variant="h4"
// // // //                 component="h2"
// // // //               >
// // // //                 {t("Edit Appointment")}
// // // //               </Typography>
// // // //               <Typography
// // // //                 onClick={handleModalClose}
// // // //                 sx={{ cursor: "pointer" }}
// // // //                 id="modal-modal-close"
// // // //                 variant="h6"
// // // //                 component="h2"
// // // //               >
// // // //                 <CloseOutlinedIcon />
// // // //               </Typography>
// // // //             </Box>
// // // //             <hr
// // // //               style={{
// // // //                 border: "none",
// // // //                 borderBottom: "1px solid #e6ebf1",
// // // //                 marginBottom: "25px",
// // // //               }}
// // // //             />
// // // //             <form onSubmit={handleSubmit}>
// // // //               <Box sx={{ "& .MuiTextField-root": { marginBottom: "1rem" } }}>
// // // //                 <FormControl
// // // //                   fullWidth
// // // //                   variant="outlined"
// // // //                   sx={{ marginBottom: "1rem" }}
// // // //                 >
// // // //                   <InputLabel id="staff-select-label">{t("Select Staff")}</InputLabel>
// // // //                   <Select
// // // //                     labelId="staff-select-label"
// // // //                     value={selectedStaff}
// // // //                     onChange={(e) => setSelectedStaff(e.target.value)}
// // // //                     label={t("Select Staff")}
// // // //                     disabled
// // // //                   >
// // // //                     {staffUsers.map((st, i) => (
// // // //                       <MenuItem
// // // //                         key={i}
// // // //                         value={st.id}
// // // //                         lastname={st.custom_user.last_name}
// // // //                       >
// // // //                         {`${st.custom_user.first_name} ${st.custom_user.last_name}`}
// // // //                       </MenuItem>
// // // //                     ))}
// // // //                   </Select>
// // // //                 </FormControl>
// // // //                 <FormControl
// // // //                   fullWidth
// // // //                   variant="outlined"
// // // //                   sx={{ marginBottom: "1rem" }}
// // // //                 >
// // // //                   <InputLabel id="client-select-label">{t("Select Client")}</InputLabel>
// // // //                   <Select
// // // //                     labelId="client-select-label"
// // // //                     value={selectedClient}
// // // //                     onChange={(e) => setSelectedClient(e.target.value)}
// // // //                     label={t("Select Client")}
// // // //                     disabled
// // // //                   >
// // // //                     {clientUsers.map((user, i) => (
// // // //                       <MenuItem
// // // //                         key={i}
// // // //                         value={user.id}
// // // //                         lastname={user.custom_user.last_name}
// // // //                       >
// // // //                         {`${user.custom_user.first_name} ${user.custom_user.last_name}`}
// // // //                       </MenuItem>
// // // //                     ))}
// // // //                   </Select>
// // // //                 </FormControl>
// // // //                 <TextField
// // // //                   fullWidth
// // // //                   type="date"
// // // //                   label={t("Date of Appointment")}
// // // //                   variant="outlined"
// // // //                   name="appointment_date"
// // // //                   InputLabelProps={{ shrink: true }}
// // // //                   value={appointment?.appointment_date || ""}
// // // //                   onChange={handleChange}
// // // //                   sx={{ mb: "1rem" }}
// // // //                 />
// // // //                 <TextField
// // // //                   fullWidth
// // // //                   type="time"
// // // //                   label={t("Time of Appointment (start)")}
// // // //                   variant="outlined"
// // // //                   name="appointment_start"
// // // //                   InputLabelProps={{ shrink: true }}
// // // //                   value={appointment?.appointment_start || ""}
// // // //                   onChange={handleChange}
// // // //                   sx={{ mb: "1rem" }}
// // // //                 />
// // // //                 <TextField
// // // //                   fullWidth
// // // //                   type="time"
// // // //                   label={t("Time of Appointment (end)")}
// // // //                   variant="outlined"
// // // //                   name="appointment_end"
// // // //                   InputLabelProps={{ shrink: true }}
// // // //                   value={appointment?.appointment_end || ""}
// // // //                   onChange={handleChange}
// // // //                   sx={{ mb: "1rem" }}
// // // //                 />
// // // //                 <Box
// // // //                   sx={{
// // // //                     display: "flex",
// // // //                     alignItems: "center",
// // // //                     mb: "1rem",
// // // //                     p: 2,
// // // //                     border: "1px solid",
// // // //                     borderColor: "grey.300",
// // // //                     borderRadius: 2,
// // // //                     bgcolor: "background.default",
// // // //                     boxShadow: 1,
// // // //                     transition: "box-shadow 0.3s ease-in-out",
// // // //                     "&:hover": {
// // // //                       boxShadow: 3,
// // // //                     },
// // // //                   }}
// // // //                 >
// // // //                   <Box sx={{ flexGrow: 1 }}>
// // // //                     <Typography
// // // //                       variant="subtitle1"
// // // //                       sx={{
// // // //                         fontWeight: "medium",
// // // //                         color: "text.primary",
// // // //                         mb: 0.5,
// // // //                       }}
// // // //                     >
// // // //                       {t("Earlier Appointment Date")}
// // // //                     </Typography>
// // // //                     <Typography
// // // //                       variant="body2"
// // // //                       sx={{
// // // //                         color: appointment?.earlier_date ? "text.primary" : "text.secondary",
// // // //                         fontStyle: appointment?.earlier_date ? "normal" : "italic",
// // // //                       }}
// // // //                     >
// // // //                       {appointment?.earlier_date
// // // //                         ? appointment.earlier_date
// // // //                         : t("No earlier appointment set")}
// // // //                     </Typography>
// // // //                   </Box>
// // // //                   <IconButton
// // // //                     onClick={handleCalendarOpen}
// // // //                     color="primary"
// // // //                     sx={{
// // // //                       bgcolor: "background.paper",
// // // //                       borderRadius: "50%",
// // // //                       p: 1,
// // // //                       "&:hover": {
// // // //                         bgcolor: "primary.main",
// // // //                         color: "grey.200",
// // // //                         transform: "scale(1.1)",
// // // //                         transition: "all 0.2s ease-in-out",
// // // //                       },
// // // //                     }}
// // // //                     aria-label={t("Select Earlier Appointment Date")}
// // // //                   >
// // // //                     <EventAvailableOutlinedIcon fontSize="medium" />
// // // //                   </IconButton>
// // // //                 </Box>
// // // //                 {showCalendar && (
// // // //                   <CalendarCheckbox
// // // //                     selectedDateCalendar={selectedDateCalendar || new Date()}
// // // //                     setSelectedDateCalendar={setSelectedDateCalendar}
// // // //                     selectedClient={selectedClient}
// // // //                     openCalendar={showCalendar}
// // // //                     setOpenCalendar={setShowCalendar}
// // // //                   />
// // // //                 )}
// // // //                 <Box sx={{ my: 2 }}>
// // // //                   <Typography
// // // //                     id="modal-modal-comments"
// // // //                     sx={{ fontSize: { xs: "16px", sm: "18px" }, fontWeight: "500" }}
// // // //                     variant="h4"
// // // //                     component="h2"
// // // //                   >
// // // //                     {t("Comments")}
// // // //                   </Typography>
// // // //                   <hr
// // // //                     style={{
// // // //                       border: "none",
// // // //                       borderBottom: "1px solid #e6ebf1",
// // // //                       marginBottom: 1,
// // // //                     }}
// // // //                   />
// // // //                   {appointment?.comments?.length > 0 ? (
// // // //                     appointment.comments.map((item, i) => (
// // // //                       <ListItem key={i}>
// // // //                         <ListItemText
// // // //                           secondary={
// // // //                             <React.Fragment>
// // // //                               <Typography
// // // //                                 component="span"
// // // //                                 variant="body2"
// // // //                                 sx={{
// // // //                                   color: "text.primary",
// // // //                                   display: "inline",
// // // //                                   mr: 1,
// // // //                                   fontWeight: "bold",
// // // //                                 }}
// // // //                               >
// // // //                                 {item?.comment_text}
// // // //                               </Typography>
// // // //                               {`— by ${item?.user?.username}`}
// // // //                             </React.Fragment>
// // // //                           }
// // // //                         />
// // // //                       </ListItem>
// // // //                     ))
// // // //                   ) : (
// // // //                     <Typography variant="body2" color="text.secondary">
// // // //                       {t("No comments available")}
// // // //                     </Typography>
// // // //                   )}
// // // //                 </Box>
// // // //               </Box>
// // // //               <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
// // // //                 <Button
// // // //                   type="submit"
// // // //                   variant="contained"
// // // //                   color="primary"
// // // //                   sx={{ minWidth: { xs: "100px", sm: "120px" } }}
// // // //                 >
// // // //                   {t("Submit")}
// // // //                 </Button>
// // // //                 {isDelete && (
// // // //                   <Button
// // // //                     type="button"
// // // //                     onClick={handleDelete}
// // // //                     variant="contained"
// // // //                     color="error"
// // // //                     sx={{ ml: 1, minWidth: { xs: "100px", sm: "120px" } }}
// // // //                   >
// // // //                     {t("Delete")}
// // // //                   </Button>
// // // //                 )}
// // // //               </Box>
// // // //             </form>
// // // //           </>
// // // //         )}
// // // //       </Box>
// // // //     </Modal>
// // // //   );
// // // // }

// // // import Modal from "@mui/material/Modal";
// // // import React, { useState, useEffect } from "react";
// // // import axiosClient from "../axiosClient";
// // // import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
// // // import {
// // //   Typography,
// // //   TextField,
// // //   Button,
// // //   Box,
// // // } from "@mui/material";
// // // import { useTranslation } from "react-i18next";

// // // const style = {
// // //   position: "absolute",
// // //   top: "50%",
// // //   left: "50%",
// // //   transform: "translate(-50%, -50%)",
// // //   width: { xs: "90vw", sm: "80vw", md: 800 },
// // //   maxHeight: "90vh",
// // //   overflowY: "auto",
// // //   bgcolor: "background.paper",
// // //   border: "2px solid #000",
// // //   boxShadow: 24,
// // //   p: { xs: 2, sm: 4 },
// // //   borderRadius: 2,
// // // };

// // // export default function AppointmentEditModal({ id, open, handleClose, refresh }) {
// // //   const { t } = useTranslation();

// // //   const [isLoading, setIsLoading] = useState(true);
// // //   const [appointment, setAppointment] = useState(null);

// // //   useEffect(() => {
// // //     if (!open || !id) return;

// // //     const load = async () => {
// // //       try {
// // //         setIsLoading(true);
// // //         const res = await axiosClient.get("/api/appointments/");
// // //         const found = (res.data || []).find((a) => a.id === id);
// // //         setAppointment(found || null);
// // //       } catch (e) {
// // //         console.log(e);
// // //         setAppointment(null);
// // //       } finally {
// // //         setIsLoading(false);
// // //       }
// // //     };

// // //     load();
// // //   }, [open, id]);

// // //   const handleChange = (e) => {
// // //     setAppointment((prev) => ({
// // //       ...prev,
// // //       [e.target.name]: e.target.value,
// // //     }));
// // //   };

// // //   const handleSubmit = async (e) => {
// // //     e.preventDefault();
// // //     if (!appointment) return;

// // //     const payload = {
// // //       issue: appointment.issue,
// // //       technician: appointment.technician,
// // //       appointment_date: appointment.appointment_date,
// // //       appointment_start:
// // //         appointment.appointment_start?.length === 5
// // //           ? `${appointment.appointment_start}:00`
// // //           : appointment.appointment_start,
// // //       appointment_end:
// // //         appointment.appointment_end?.length === 5
// // //           ? `${appointment.appointment_end}:00`
// // //           : appointment.appointment_end,
// // //       requester_informed: !!appointment.requester_informed,
// // //       requester_arrival: !!appointment.requester_arrival,
// // //     };

// // //     try {
// // //       await axiosClient.put(`/api/appointments/${id}/`, payload);
// // //       refresh?.();
// // //       handleClose();
// // //     } catch (err) {
// // //       console.log(err);
// // //       alert(
// // //         err?.response?.status === 404
// // //           ? "Your backend does not have PUT /api/appointments/<id>/ yet."
// // //           : "Failed to update appointment"
// // //       );
// // //     }
// // //   };

// // //   const handleDelete = async () => {
// // //     try {
// // //       await axiosClient.delete(`/api/appointments/${id}/`);
// // //       refresh?.();
// // //       handleClose();
// // //     } catch (err) {
// // //       console.log(err);
// // //       alert(
// // //         err?.response?.status === 404
// // //           ? "Your backend does not have DELETE /api/appointments/<id>/ yet."
// // //           : "Failed to delete appointment"
// // //       );
// // //     }
// // //   };

// // //   return (
// // //     <Modal open={open} onClose={handleClose}>
// // //       <Box sx={style}>
// // //         {isLoading ? (
// // //           <Typography>Loading...</Typography>
// // //         ) : !appointment ? (
// // //           <Typography>Appointment not found.</Typography>
// // //         ) : (
// // //           <>
// // //             <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1 }}>
// // //               <Typography variant="h5">{t("Edit Appointment")}</Typography>
// // //               <Typography onClick={handleClose} sx={{ cursor: "pointer" }}>
// // //                 <CloseOutlinedIcon />
// // //               </Typography>
// // //             </Box>
// // //             <hr style={{ border: "none", borderBottom: "1px solid #e6ebf1", marginBottom: "25px" }} />

// // //             <form onSubmit={handleSubmit}>
// // //               <TextField
// // //                 fullWidth
// // //                 type="date"
// // //                 label={t("Date of Appointment")}
// // //                 variant="outlined"
// // //                 name="appointment_date"
// // //                 InputLabelProps={{ shrink: true }}
// // //                 value={appointment.appointment_date || ""}
// // //                 onChange={handleChange}
// // //                 sx={{ mb: "1rem" }}
// // //               />

// // //               <TextField
// // //                 fullWidth
// // //                 type="time"
// // //                 label={t("Time of Appointment (start)")}
// // //                 variant="outlined"
// // //                 name="appointment_start"
// // //                 InputLabelProps={{ shrink: true }}
// // //                 value={appointment.appointment_start || ""}
// // //                 onChange={handleChange}
// // //                 sx={{ mb: "1rem" }}
// // //               />

// // //               <TextField
// // //                 fullWidth
// // //                 type="time"
// // //                 label={t("Time of Appointment (end)")}
// // //                 variant="outlined"
// // //                 name="appointment_end"
// // //                 InputLabelProps={{ shrink: true }}
// // //                 value={appointment.appointment_end || ""}
// // //                 onChange={handleChange}
// // //                 sx={{ mb: "1rem" }}
// // //               />

// // //               <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
// // //                 <Button type="submit" variant="contained" sx={{ minWidth: 120 }}>
// // //                   {t("Submit")}
// // //                 </Button>
// // //                 <Button
// // //                   type="button"
// // //                   onClick={handleDelete}
// // //                   variant="contained"
// // //                   color="error"
// // //                   sx={{ ml: 1, minWidth: 120 }}
// // //                 >
// // //                   {t("Delete")}
// // //                 </Button>
// // //               </Box>
// // //             </form>
// // //           </>
// // //         )}
// // //       </Box>
// // //     </Modal>
// // //   );
// // // }

// // import React, { useState, useEffect } from "react";
// // import {
// //   Dialog, DialogTitle, DialogContent, DialogActions,
// //   Button, TextField, Box, Typography, Alert, CircularProgress
// // } from "@mui/material";
// // import { useTranslation } from "react-i18next";
// // import axiosClient from "../axiosClient";

// // const AppointmentEditModal = ({ open, id, handleClose, refresh }) => {
// //   const { t } = useTranslation();
// //   const [loading, setLoading] = useState(false);
// //   const [appointment, setAppointment] = useState(null);
  
// //   const [formData, setFormData] = useState({
// //     appointment_date: "",
// //     appointment_start: "",
// //     appointment_end: "",
// //   });

// //   useEffect(() => {
// //     if (open && id) {
// //       setLoading(true);
// //       axiosClient.get(`/api/appointments/${id}/`)
// //         .then((res) => {
// //           setAppointment(res.data);
// //           setFormData({
// //             appointment_date: res.data.appointment_date,
// //             appointment_start: res.data.appointment_start,
// //             appointment_end: res.data.appointment_end,
// //           });
// //           setLoading(false);
// //         })
// //         .catch((err) => {
// //           console.error("Fetch Error:", err);
// //           setLoading(false);
// //         });
// //     }
// //   }, [open, id]);

// //   const handleChange = (e) => {
// //     setFormData({ ...formData, [e.target.name]: e.target.value });
// //   };

// //   const handleSubmit = () => {
// //     axiosClient.patch(`/api/appointments/${id}/`, formData)
// //       .then(() => {
// //         refresh();
// //         handleClose();
// //       })
// //       .catch((err) => console.error("Update Error:", err));
// //   };

// //   // 🛠️ FIX: Ensure deletion triggers the refresh and closes the modal
// //   const handleDelete = () => {
// //     if (window.confirm(t("Are you sure you want to delete this appointment?"))) {
// //       axiosClient.delete(`/api/appointments/${id}/`)
// //         .then(() => {
// //           // IMPORTANT: Must call refresh() to update the calendar view
// //           refresh(); 
// //           handleClose();
// //         })
// //         .catch((err) => {
// //           console.error("Delete Error:", err);
// //           alert(t("Delete failed. Please check server connection."));
// //         });
// //     }
// //   };

// //   return (
// //     <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
// //       <DialogTitle sx={{ fontWeight: "bold" }}>{t("EDIT APPOINTMENT")}</DialogTitle>
// //       <DialogContent>
// //         {loading ? (
// //           <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}><CircularProgress /></Box>
// //         ) : (
// //           <Box sx={{ mt: 1 }}>
// //             {/* 🆕 ROOM NUMBER DISPLAY (From Issue Info) */}
// //             {appointment?.issue_info?.room_number && (
// //               <Alert severity="info" icon={false} sx={{ mb: 2, fontWeight: 'bold' }}>
// //                 {t("LOCATION")}: {appointment.issue_info.room_number}
// //               </Alert>
// //             )}

// //             <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
// //               {t("Linked Issue")}: <strong>{appointment?.issue_info?.title || t("No Title")}</strong>
// //             </Typography>

// //             <TextField
// //               margin="normal"
// //               fullWidth
// //               label={t("DATE OF APPOINTMENT")}
// //               type="date"
// //               name="appointment_date"
// //               value={formData.appointment_date || ""}
// //               onChange={handleChange}
// //               InputLabelProps={{ shrink: true }}
// //             />
// //             <TextField
// //               margin="normal"
// //               fullWidth
// //               label={t("TIME OF APPOINTMENT (START)")}
// //               type="time"
// //               name="appointment_start"
// //               value={formData.appointment_start || ""}
// //               onChange={handleChange}
// //               InputLabelProps={{ shrink: true }}
// //             />
// //             <TextField
// //               margin="normal"
// //               fullWidth
// //               label={t("TIME OF APPOINTMENT (END)")}
// //               type="time"
// //               name="appointment_end"
// //               value={formData.appointment_end || ""}
// //               onChange={handleChange}
// //               InputLabelProps={{ shrink: true }}
// //             />
// //           </Box>
// //         )}
// //       </DialogContent>
// //       <DialogActions sx={{ px: 3, pb: 2, justifyContent: 'space-between' }}>
// //         {/* DELETE BUTTON */}
// //         <Button onClick={handleDelete} variant="contained" color="error">
// //           {t("DELETE")}
// //         </Button>
// //         <Box>
// //           <Button onClick={handleClose} sx={{ mr: 1 }}>{t("CANCEL")}</Button>
// //           <Button onClick={handleSubmit} variant="contained" color="primary">
// //             {t("SUBMIT")}
// //           </Button>
// //         </Box>
// //       </DialogActions>
// //     </Dialog>
// //   );
// // };

// // export default AppointmentEditModal;


// import React, { useState, useEffect } from "react";
// import {
//   Dialog, DialogTitle, DialogContent, DialogActions,
//   Button, TextField, Box, Typography, Alert, CircularProgress
// } from "@mui/material";
// import { useTranslation } from "react-i18next";
// import axiosClient from "../axiosClient";

// const AppointmentEditModal = ({ open, id, handleClose, refresh }) => {
//   const { t } = useTranslation();
//   const [loading, setLoading] = useState(false);
//   const [appointment, setAppointment] = useState(null);
  
//   const [formData, setFormData] = useState({
//     appointment_date: "",
//     appointment_start: "",
//     appointment_end: "",
//   });

//   useEffect(() => {
//     if (open && id) {
//       setLoading(true);
//       // ✅ FIX: Ensure the ID is clean and the URL ends with a slash /
//       const cleanId = String(id).split(':')[0]; 
//       axiosClient.get(`/api/appointments/${cleanId}/`) 
//         .then((res) => {
//           setAppointment(res.data);
//           setFormData({
//             appointment_date: res.data.appointment_date,
//             appointment_start: res.data.appointment_start,
//             appointment_end: res.data.appointment_end,
//           });
//           setLoading(false);
//         })
//         .catch((err) => {
//           console.error("Fetch Error:", err);
//           setLoading(false);
//         });
//     }
//   }, [open, id]);

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = () => {
//     const cleanId = String(id).split(':')[0];
//     axiosClient.patch(`/api/appointments/${cleanId}/`, formData)
//       .then(() => {
//         refresh();
//         handleClose();
//       })
//       .catch((err) => console.error("Update Error:", err));
//   };

//   const handleDelete = () => {
//     if (window.confirm(t("Are you sure you want to delete this appointment?"))) {
//       const cleanId = String(id).split(':')[0];
//       // ✅ FIX: Add the trailing slash to satisfy the 405 error
//       axiosClient.delete(`/api/appointments/${cleanId}/`)
//         .then(() => {
//           refresh();
//           handleClose();
//         })
//         .catch((err) => {
//           console.error("Delete Error:", err);
//           alert(t("Delete failed. Check backend permissions."));
//         });
//     }
//   };

//   return (
//     <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
//       <DialogTitle sx={{ fontWeight: "bold" }}>{t("EDIT APPOINTMENT")}</DialogTitle>
//       <DialogContent>
//         {loading ? (
//           <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}><CircularProgress /></Box>
//         ) : (
//           <Box sx={{ mt: 1 }}>
            
//             {/* 🆕 ROOM NUMBER DISPLAY */}
//             {appointment?.issue_info?.room_number && (
//               <Alert severity="success" icon={false} sx={{ mb: 2, fontWeight: 'bold' }}>
//                 {t("LOCATION")}: {appointment.issue_info.room_number}
//               </Alert>
//             )}

//             <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
//               {t("Linked Issue")}: <strong>{appointment?.issue_info?.title || t("No Title")}</strong>
//             </Typography>

//             <TextField
//               margin="normal"
//               fullWidth
//               label={t("DATE OF APPOINTMENT")}
//               type="date"
//               name="appointment_date"
//               value={formData.appointment_date || ""}
//               onChange={handleChange}
//               InputLabelProps={{ shrink: true }}
//             />
//             <TextField
//               margin="normal"
//               fullWidth
//               label={t("TIME OF APPOINTMENT (START)")}
//               type="time"
//               name="appointment_start"
//               value={formData.appointment_start || ""}
//               onChange={handleChange}
//               InputLabelProps={{ shrink: true }}
//             />
//             <TextField
//               margin="normal"
//               fullWidth
//               label={t("TIME OF APPOINTMENT (END)")}
//               type="time"
//               name="appointment_end"
//               value={formData.appointment_end || ""}
//               onChange={handleChange}
//               InputLabelProps={{ shrink: true }}
//             />
//           </Box>
//         )}
//       </DialogContent>
//       <DialogActions sx={{ px: 3, pb: 2, justifyContent: 'space-between' }}>
//         <Button onClick={handleDelete} variant="contained" color="error">
//           {t("DELETE")}
//         </Button>
//         <Box>
//           <Button onClick={handleClose} sx={{ mr: 1 }}>{t("CANCEL")}</Button>
//           <Button onClick={handleSubmit} variant="contained" color="primary">
//             {t("SUBMIT")}
//           </Button>
//         </Box>
//       </DialogActions>
//     </Dialog>
//   );
// };

// export default AppointmentEditModal;


/////////////////////////////////////////////////////////////////////

// import React, { useState, useEffect } from "react";
// import {
//   Dialog, DialogTitle, DialogContent, DialogActions,
//   Button, TextField, Box, Typography, Alert, CircularProgress
// } from "@mui/material";
// import { useTranslation } from "react-i18next";
// import axiosClient from "../axiosClient";

// const AppointmentEditModal = ({ open, id, handleClose, refresh }) => {
//   const { t } = useTranslation();
//   const [loading, setLoading] = useState(false);
//   const [appointment, setAppointment] = useState(null);
  
//   const [formData, setFormData] = useState({
//     appointment_date: "",
//     appointment_start: "",
//     appointment_end: "",
//   });

//   // Helper to ensure the ID is a clean number and the URL has a trailing slash
//   const getCleanUrl = (appointmentId) => {
//     const cleanId = String(appointmentId).split(':')[0]; // Removes accidental ":1"
//     return `/api/appointments/${cleanId}/`; // Adds mandatory trailing slash
//   };

//   useEffect(() => {
//     if (open && id) {
//       setLoading(true);
//       axiosClient.get(getCleanUrl(id))
//         .then((res) => {
//           setAppointment(res.data);
//           setFormData({
//             appointment_date: res.data.appointment_date,
//             appointment_start: res.data.appointment_start,
//             appointment_end: res.data.appointment_end,
//           });
//           setLoading(false);
//         })
//         .catch((err) => {
//           console.error("Fetch Error:", err);
//           setLoading(false);
//         });
//     }
//   }, [open, id]);

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = () => {
//     axiosClient.patch(getCleanUrl(id), formData)
//       .then(() => {
//         refresh();
//         handleClose();
//       })
//       .catch((err) => console.error("Update Error:", err));
//   };

//   const handleDelete = () => {
//     if (window.confirm(t("Are you sure you want to delete this appointment?"))) {
//       axiosClient.delete(getCleanUrl(id))
//         .then(() => {
//           refresh();
//           handleClose();
//         })
//         .catch((err) => {
//           console.error("Delete Error:", err);
//           alert(t("Delete failed. Check backend permissions."));
//         });
//     }
//   };

//   return (
//     <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
//       <DialogTitle sx={{ fontWeight: "bold" }}>{t("EDIT APPOINTMENT")}</DialogTitle>
//       <DialogContent>
//         {loading ? (
//           <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}><CircularProgress /></Box>
//         ) : (
//           <Box sx={{ mt: 1 }}>
            
//             {/* 🆕 ROOM NUMBER DISPLAY */}
//             {appointment?.issue_info?.room_number && (
//               <Alert severity="success" icon={false} sx={{ mb: 2, fontWeight: 'bold' }}>
//                 {t("LOCATION / ROOM")}: {appointment.issue_info.room_number}
//               </Alert>
//             )}

//             <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
//               {t("Linked Issue")}: <strong>{appointment?.issue_info?.title || t("No Title")}</strong>
//             </Typography>

//             <TextField
//               margin="normal"
//               fullWidth
//               label={t("DATE OF APPOINTMENT")}
//               type="date"
//               name="appointment_date"
//               value={formData.appointment_date || ""}
//               onChange={handleChange}
//               InputLabelProps={{ shrink: true }}
//             />
//             <TextField
//               margin="normal"
//               fullWidth
//               label={t("TIME OF APPOINTMENT (START)")}
//               type="time"
//               name="appointment_start"
//               value={formData.appointment_start || ""}
//               onChange={handleChange}
//               InputLabelProps={{ shrink: true }}
//             />
//             <TextField
//               margin="normal"
//               fullWidth
//               label={t("TIME OF APPOINTMENT (END)")}
//               type="time"
//               name="appointment_end"
//               value={formData.appointment_end || ""}
//               onChange={handleChange}
//               InputLabelProps={{ shrink: true }}
//             />
//           </Box>
//         )}
//       </DialogContent>
//       <DialogActions sx={{ px: 3, pb: 2, justifyContent: 'space-between' }}>
//         <Button onClick={handleDelete} variant="contained" color="error">
//           {t("DELETE")}
//         </Button>
//         <Box>
//           <Button onClick={handleClose} sx={{ mr: 1 }}>{t("CANCEL")}</Button>
//           <Button onClick={handleSubmit} variant="contained" color="primary">
//             {t("SUBMIT")}
//           </Button>
//         </Box>
//       </DialogActions>
//     </Dialog>
//   );
// };

// export default AppointmentEditModal;


/////////////////////////////////////////////////////////////////////

// import React, { useState, useEffect } from "react";
// import {
//   Dialog, DialogTitle, DialogContent, DialogActions,
//   Button, TextField, Box, Typography, Divider,
//   Stack, IconButton, CircularProgress
// } from "@mui/material";
// import CloseIcon from "@mui/icons-material/Close";
// import DeleteIcon from "@mui/icons-material/Delete";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import { useTranslation } from "react-i18next";
// import axiosClient from "../axiosClient";

// const AppointmentEditModal = ({ open, id, handleClose, refresh }) => {
//   const { t } = useTranslation();
//   const [loading, setLoading] = useState(false);
//   const [appointment, setAppointment] = useState(null);
  
//   const [formData, setFormData] = useState({
//     title: "", 
//     appointment_date: "",
//     appointment_start: "", 
//     appointment_end: "",   
//   });

//   const getCleanUrl = (appointmentId) => {
//     const cleanId = String(appointmentId).split(':')[0];
//     return `/api/appointments/${cleanId}/`;
//   };

//   useEffect(() => {
//     if (open && id) {
//       setLoading(true);
//       axiosClient.get(getCleanUrl(id))
//         .then((res) => {
//           setAppointment(res.data);
//           // 🛠️ Existing values from DB are placed into the form state immediately
//           setFormData({
//             title: res.data.issue_info?.title || "",
//             appointment_date: res.data.appointment_date || "",
//             appointment_start: res.data.appointment_start || "", 
//             appointment_end: res.data.appointment_end || "",
//           });
//           setLoading(false);
//         })
//         .catch((err) => {
//           console.error("Fetch Error:", err);
//           setLoading(false);
//         });
//     }
//   }, [open, id]);

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleUpdate = () => {
//     axiosClient.patch(getCleanUrl(id), formData)
//       .then(() => {
//         refresh();
//         handleClose();
//       })
//       .catch((err) => console.error("Update Error:", err));
//   };

//   const handleCloseTask = () => {
//     if (window.confirm(t("Mark this task as completed?"))) {
//       axiosClient.post(`/api/close-issue/${appointment.issue}/`, {
//         status: 'closed',
//         end_time: new Date().toISOString()
//       }).then(() => {
//         refresh();
//         handleClose();
//       });
//     }
//   };

//   const handleDeleteIssue = () => {
//     if (window.confirm(t("Permanently delete this entire issue?"))) {
//       axiosClient.delete(`/api/issues/${appointment.issue}/`)
//         .then(() => {
//           refresh();
//           handleClose();
//         });
//     }
//   };

//   return (
//     <Dialog 
//       open={open} 
//       onClose={handleClose} 
//       fullWidth 
//       maxWidth="xs"
//       PaperProps={{ sx: { bgcolor: '#1e1e1e', backgroundImage: 'none' } }}
//     >
//       {/* 🛠️ TASK DETAILS TITLE BAR */}
//       <DialogTitle sx={{ p: 2, fontWeight: "bold", bgcolor: '#333', color: '#fff', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//         {t("TASK DETAILS")}
//         <IconButton onClick={handleClose} sx={{ color: '#fff' }}><CloseIcon /></IconButton>
//       </DialogTitle>

//       <DialogContent sx={{ p: 3 }}>
//         {loading ? (
//           <Box sx={{ display: 'flex', justifyContent: 'center', p: 5 }}><CircularProgress color="inherit" /></Box>
//         ) : (
//           <Stack spacing={3} sx={{ mt: 1 }}>
            
//             {/* 🛠️ 1. EDITABLE TASK NAME / TITLE */}
//             <TextField
//               fullWidth
//               label={t("TASK NAME")}
//               name="title"
//               value={formData.title}
//               onChange={handleChange}
//               variant="outlined"
//               sx={{ 
//                 input: { color: 'white' }, 
//                 label: { color: '#888' }, 
//                 '& .MuiOutlinedInput-root': { '& fieldset': { borderColor: '#444' } } 
//               }}
//             />

//             <Divider sx={{ borderColor: '#333' }} />

//             {/* 🛠️ 2. DATE OF TASK */}
//             <TextField
//               fullWidth
//               label={t("DATE OF TASK")}
//               type="date"
//               name="appointment_date"
//               value={formData.appointment_date || ""}
//               onChange={handleChange}
//               InputLabelProps={{ shrink: true }}
//               sx={{ input: { color: 'white' }, label: { color: '#888' }, '& .MuiOutlinedInput-root': { '& fieldset': { borderColor: '#444' } } }}
//             />

//             {/* 🛠️ 3. TASK TIMES (LOADED FROM DB) */}
//             <Stack direction="row" spacing={2}>
//               <TextField
//                 fullWidth
//                 label={t("START TIME")}
//                 type="time"
//                 name="appointment_start"
//                 value={formData.appointment_start || ""}
//                 onChange={handleChange}
//                 InputLabelProps={{ shrink: true }}
//                 sx={{ input: { color: 'white' }, label: { color: '#888' }, '& .MuiOutlinedInput-root': { '& fieldset': { borderColor: '#444' } } }}
//               />
//               <TextField
//                 fullWidth
//                 label={t("END TIME")}
//                 type="time"
//                 name="appointment_end"
//                 value={formData.appointment_end || ""}
//                 onChange={handleChange}
//                 InputLabelProps={{ shrink: true }}
//                 sx={{ input: { color: 'white' }, label: { color: '#888' }, '& .MuiOutlinedInput-root': { '& fieldset': { borderColor: '#444' } } }}
//               />
//             </Stack>
//           </Stack>
//         )}
//       </DialogContent>

//       <DialogActions sx={{ p: 2, bgcolor: '#1e1e1e', flexDirection: 'column', gap: 1 }}>
//         <Stack direction="row" spacing={1} sx={{ width: '100%' }}>
//           <Button 
//             fullWidth 
//             variant="contained" 
//             sx={{ bgcolor: '#4caf50', fontWeight: 'bold' }}
//             startIcon={<CheckCircleIcon />}
//             onClick={handleCloseTask}
//           >
//             {t("CLOSE TASK")}
//           </Button>
          
//           <Button 
//             fullWidth 
//             variant="contained" 
//             sx={{ fontWeight: 'bold' }} 
//             onClick={handleUpdate}
//           >
//             {t("SAVE")}
//           </Button>
//         </Stack>

//         <Button 
//           fullWidth 
//           variant="text" 
//           color="error" 
//           startIcon={<DeleteIcon />}
//           onClick={handleDeleteIssue}
//           sx={{ fontSize: '0.8rem', mt: 1 }}
//         >
//           {t("DELETE ENTIRE ISSUE")}
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// };

// export default AppointmentEditModal;


////////////////////////////////////////////////////////////


// import React, { useState, useEffect } from "react";
// import {
//   Dialog, DialogTitle, DialogContent, DialogActions,
//   Button, TextField, Box, Stack, IconButton, CircularProgress, Divider
// } from "@mui/material";
// import CloseIcon from "@mui/icons-material/Close";
// import DeleteIcon from "@mui/icons-material/Delete";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import { useTranslation } from "react-i18next";
// import axiosClient from "../axiosClient";

// const AppointmentEditModal = ({ open, id, handleClose, refresh }) => {
//   const { t } = useTranslation();
//   const [loading, setLoading] = useState(false);
//   const [appointment, setAppointment] = useState(null);
  
//   const [formData, setFormData] = useState({
//     title: "", 
//     appointment_date: "",
//     appointment_start: "", 
//     appointment_end: "",   
//   });

//   const getCleanUrl = (appointmentId) => {
//     const cleanId = String(appointmentId).split(':')[0];
//     return `/api/appointments/${cleanId}/`;
//   };

//   useEffect(() => {
//     if (open && id) {
//       setLoading(true);
//       axiosClient.get(getCleanUrl(id))
//         .then((res) => {
//           const data = res.data;
//           setAppointment(data);

//           // 🛠️ THE FIX: Format the date and times so the HTML boxes can read them
//           // We ensure appointment_date is only YYYY-MM-DD
//           const rawDate = data.appointment_date ? data.appointment_date.split('T')[0] : "";
          
//           setFormData({
//             title: data.issue_info?.title || "",
//             appointment_date: rawDate, 
//             appointment_start: data.appointment_start || "", 
//             appointment_end: data.appointment_end || "",
//           });
//           setLoading(false);
//         })
//         .catch((err) => {
//           console.error("Fetch Error:", err);
//           setLoading(false);
//         });
//     }
//   }, [open, id]);

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleUpdate = () => {
//     axiosClient.patch(getCleanUrl(id), formData)
//       .then(() => {
//         refresh();
//         handleClose();
//       })
//       .catch((err) => console.error("Update Error:", err));
//   };

//   const handleCloseTask = () => {
//     if (window.confirm(t("Mark this task as completed?"))) {
//       axiosClient.post(`/api/close-issue/${appointment.issue}/`, {
//         status: 'closed',
//         end_time: new Date().toISOString()
//       }).then(() => {
//         refresh();
//         handleClose();
//       });
//     }
//   };

//   const handleDeleteIssue = () => {
//     if (window.confirm(t("Permanently delete this entire issue?"))) {
//       axiosClient.delete(`/api/issues/${appointment.issue}/`)
//         .then(() => {
//           refresh();
//           handleClose();
//         });
//     }
//   };

//   return (
//     <Dialog 
//       open={open} 
//       onClose={handleClose} 
//       fullWidth 
//       maxWidth="xs"
//       PaperProps={{ sx: { bgcolor: '#1e1e1e', backgroundImage: 'none' } }}
//     >
//       <DialogTitle sx={{ p: 2, fontWeight: "bold", bgcolor: '#333', color: '#fff', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//         {t("TASK DETAILS")}
//         <IconButton onClick={handleClose} sx={{ color: '#fff' }}><CloseIcon /></IconButton>
//       </DialogTitle>

//       <DialogContent sx={{ p: 3 }}>
//         {loading ? (
//           <Box sx={{ display: 'flex', justifyContent: 'center', p: 5 }}><CircularProgress color="inherit" /></Box>
//         ) : (
//           <Stack spacing={3} sx={{ mt: 1 }}>
            
//             <TextField
//               fullWidth
//               label={t("TASK NAME")}
//               name="title"
//               value={formData.title}
//               onChange={handleChange}
//               variant="outlined"
//               sx={{ input: { color: 'white' }, label: { color: '#888' }, '& .MuiOutlinedInput-root': { '& fieldset': { borderColor: '#444' } } }}
//             />

//             <Divider sx={{ borderColor: '#333' }} />

//             <TextField
//               fullWidth
//               label={t("DATE OF TASK")}
//               type="date"
//               name="appointment_date"
//               value={formData.appointment_date} // 🗓️ Pre-filled value
//               onChange={handleChange}
//               InputLabelProps={{ shrink: true }}
//               sx={{ input: { color: 'white' }, label: { color: '#888' }, '& .MuiOutlinedInput-root': { '& fieldset': { borderColor: '#444' } } }}
//             />

//             <Stack direction="row" spacing={2}>
//               <TextField
//                 fullWidth
//                 label={t("START TIME")}
//                 type="time"
//                 name="appointment_start"
//                 value={formData.appointment_start} // 🕒 Pre-filled value
//                 onChange={handleChange}
//                 InputLabelProps={{ shrink: true }}
//                 sx={{ input: { color: 'white' }, label: { color: '#888' }, '& .MuiOutlinedInput-root': { '& fieldset': { borderColor: '#444' } } }}
//               />
//               <TextField
//                 fullWidth
//                 label={t("END TIME")}
//                 type="time"
//                 name="appointment_end"
//                 value={formData.appointment_end} // 🕒 Pre-filled value
//                 onChange={handleChange}
//                 InputLabelProps={{ shrink: true }}
//                 sx={{ input: { color: 'white' }, label: { color: '#888' }, '& .MuiOutlinedInput-root': { '& fieldset': { borderColor: '#444' } } }}
//               />
//             </Stack>
//           </Stack>
//         )}
//       </DialogContent>

//       <DialogActions sx={{ p: 2, bgcolor: '#1e1e1e', flexDirection: 'column', gap: 1 }}>
//         <Stack direction="row" spacing={1} sx={{ width: '100%' }}>
//           <Button 
//             fullWidth 
//             variant="contained" 
//             sx={{ bgcolor: '#4caf50', fontWeight: 'bold' }}
//             startIcon={<CheckCircleIcon />}
//             onClick={handleCloseTask}
//           >
//             {t("CLOSE TASK")}
//           </Button>
          
//           <Button 
//             fullWidth 
//             variant="contained" 
//             sx={{ fontWeight: 'bold' }} 
//             onClick={handleUpdate}
//           >
//             {t("SAVE")}
//           </Button>
//         </Stack>

//         <Button 
//           fullWidth 
//           variant="text" 
//           color="error" 
//           startIcon={<DeleteIcon />}
//           onClick={handleDeleteIssue}
//           sx={{ fontSize: '0.8rem', mt: 1 }}
//         >
//           {t("DELETE ENTIRE ISSUE")}
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// };

// export default AppointmentEditModal;



// import React, { useState, useEffect } from "react";
// import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Stack, CircularProgress } from "@mui/material";
// import axiosClient from "../axiosClient";

// const AppointmentEditModal = ({ open, id, handleClose, refresh }) => {
//   const [loading, setLoading] = useState(false);
//   const [formData, setFormData] = useState({
//     title: "", appointment_date: "", appointment_start: "", appointment_end: ""
//   });

//   useEffect(() => {
//     if (open && id) {
//       setLoading(true);
//       const cleanId = String(id).split(':')[0];
//       axiosClient.get(`/api/appointments/${cleanId}/`)
//         .then((res) => {
//           console.log("DATA FROM DB:", res.data); // 🛠️ Check your console for this!
//           const d = res.data;
          
//           setFormData({
//             title: d.title || d.issue_info?.title || "",
//             // This tries different possible names for the date and time
//             appointment_date: (d.appointment_date || d.date || "").split('T')[0],
//             appointment_start: (d.appointment_start || d.start_time || "").slice(0, 5),
//             appointment_end: (d.appointment_end || d.end_time || "").slice(0, 5),
//           });
//           setLoading(false);
//         })
//         .catch(() => setLoading(false));
//     }
//   }, [open, id]);

//   return (
//     <Dialog open={open} onClose={handleClose} fullWidth maxWidth="xs">
//       <DialogTitle sx={{ fontWeight: 'bold' }}>TASK DETAILS</DialogTitle>
//       <DialogContent dividers>
//         {loading ? <CircularProgress /> : (
//           <Stack spacing={3} sx={{ mt: 1 }}>
//             <TextField fullWidth label="TASK NAME" name="title" value={formData.title} onChange={(e) => setFormData({...formData, title: e.target.value})} />
//             <TextField fullWidth label="DATE OF TASK" type="date" value={formData.appointment_date} InputLabelProps={{ shrink: true }} onChange={(e) => setFormData({...formData, appointment_date: e.target.value})} />
//             <Stack direction="row" spacing={2}>
//               <TextField fullWidth label="START" type="time" value={formData.appointment_start} InputLabelProps={{ shrink: true }} onChange={(e) => setFormData({...formData, appointment_start: e.target.value})} />
//               <TextField fullWidth label="END" type="time" value={formData.appointment_end} InputLabelProps={{ shrink: true }} onChange={(e) => setFormData({...formData, appointment_end: e.target.value})} />
//             </Stack>
//           </Stack>
//         )}
//       </DialogContent>
//       <DialogActions>
//         <Button onClick={handleClose}>CANCEL</Button>
//         <Button variant="contained" color="success" onClick={() => {
//           axiosClient.patch(`/api/appointments/${id.split(':')[0]}/`, formData).then(() => { refresh(); handleClose(); });
//         }}>SAVE</Button>
//       </DialogActions>
//     </Dialog>
//   );
// };

// export default AppointmentEditModal;
//////////////////////////////////////////////////////


// import React, { useState, useEffect } from "react";
// import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Stack, CircularProgress, Box } from "@mui/material";
// import axiosClient from "../axiosClient";
// import dayjs from "dayjs";

// const AppointmentEditModal = ({ open, id, handleClose, refresh }) => {
//   const [loading, setLoading] = useState(false);
//   const [formData, setFormData] = useState({ title: "", appointment_date: "", appointment_start: "", appointment_end: "" });

//   useEffect(() => {
//     if (open && id) {
//       setLoading(true);
//       const cleanId = String(id).replace('issue-', '').split(':')[0];
//       axiosClient.get(`/api/issues/${cleanId}/`)
//         .then((res) => {
//           const d = res.data;
//           let datePart = ""; let startPart = ""; let endPart = "";

//           // 🛠️ RESOLUTION: Flip 15-03-2026 to 2026-03-15 so the box works
//           const startStr = d.reported || "";
//           if (startStr.includes(' ')) {
//             const parts = startStr.split(' ');
//             const dateBits = parts[0].split('-');
//             if (dateBits.length === 3) datePart = `${dateBits[2]}-${dateBits[1]}-${dateBits[0]}`;
//             startPart = parts[1].substring(0, 5);
//           }
//           const finishStr = d.finish_time || "";
//           if (finishStr.includes(' ')) endPart = finishStr.split(' ')[1].substring(0, 5);

//           setFormData({ title: d.title || "", appointment_date: datePart, appointment_start: startPart, appointment_end: endPart });
//           setLoading(false);
//         })
//         .catch(() => setLoading(false));
//     }
//   }, [open, id]);

//   const handleSave = () => {
//     const cleanId = String(id).replace('issue-', '').split(':')[0];
//     // 🛠️ RESOLUTION: Send hard-coded strings to bypass UTC conversion
//     const payload = {
//       title: formData.title,
//       reported: `${dayjs(formData.appointment_date).format("DD-MM-YYYY")} ${formData.appointment_start}`,
//       finish_time: `${dayjs(formData.appointment_date).format("DD-MM-YYYY")} ${formData.appointment_end}`
//     };
//     axiosClient.patch(`/api/issues/${cleanId}/`, payload).then(() => { refresh(); handleClose(); });
//   };

//   return (
//     <Dialog open={open} onClose={handleClose} fullWidth maxWidth="xs" PaperProps={{ sx: { bgcolor: '#1e1e1e', color: 'white' } }}>
//       <DialogTitle sx={{ fontWeight: 'bold' }}>TASK DETAILS</DialogTitle>
//       <DialogContent dividers sx={{ borderColor: '#333' }}>
//         {loading ? <CircularProgress /> : (
//           <Stack spacing={3} sx={{ mt: 1 }}>
//             <TextField fullWidth label="TASK NAME" value={formData.title} onChange={(e) => setFormData({...formData, title: e.target.value})} sx={inputStyle} />
//             <TextField fullWidth label="DATE" type="date" value={formData.appointment_date} InputLabelProps={{ shrink: true }} onChange={(e) => setFormData({...formData, appointment_date: e.target.value})} sx={inputStyle} />
//             <Stack direction="row" spacing={2}>
//               <TextField fullWidth label="START" type="time" value={formData.appointment_start} InputLabelProps={{ shrink: true }} onChange={(e) => setFormData({...formData, appointment_start: e.target.value})} sx={inputStyle} />
//               <TextField fullWidth label="END" type="time" value={formData.appointment_end} InputLabelProps={{ shrink: true }} onChange={(e) => setFormData({...formData, appointment_end: e.target.value})} sx={inputStyle} />
//             </Stack>
//           </Stack>
//         )}
//       </DialogContent>
//       <DialogActions><Button onClick={handleClose}>CANCEL</Button><Button variant="contained" color="success" onClick={handleSave}>SAVE</Button></DialogActions>
//     </Dialog>
//   );
// };

// const inputStyle = { '& .MuiOutlinedInput-root': { color: 'white', '& fieldset': { borderColor: '#777' } }, '& .MuiInputLabel-root': { color: '#aaa' } };
// export default AppointmentEditModal;

////////////////////////////////////////

// import React, { useState, useEffect } from "react";
// import { 
//   Dialog, DialogTitle, DialogContent, DialogActions, 
//   Button, TextField, Stack, CircularProgress, Box 
// } from "@mui/material";
// import axiosClient from "../axiosClient";
// import dayjs from "dayjs";

// const AppointmentEditModal = ({ open, id, handleClose, refresh }) => {
//   const [loading, setLoading] = useState(false);
//   const [formData, setFormData] = useState({
//     title: "", 
//     appointment_date: "", 
//     appointment_start: "", 
//     appointment_end: ""
//   });

//   useEffect(() => {
//     if (open && id) {
//       setLoading(true);
//       const cleanId = String(id).replace('issue-', '').split(':')[0];
      
//       axiosClient.get(`/api/issues/${cleanId}/`)
//         .then((res) => {
//           const d = res.data;
          
//           // 🛠️ PRINT TO CONSOLE: Check this to see the raw data from server
//           console.log("RAW DATA FROM DATABASE:", d);

//           let datePart = "";
//           let startPart = "";
//           let endPart = "";

//           // 1. Process Reported (Start) Date and Time
//           if (d.reported && d.reported.includes(' ')) {
//             const parts = d.reported.split(' ');
//             const bits = parts[0].split('-');
//             // Browser requires YYYY-MM-DD
//             if (bits.length === 3) datePart = `${bits[2]}-${bits[1]}-${bits[0]}`;
//             startPart = parts[1].substring(0, 5);
//           }

//           // 2. Process Finish (End) Time
//           // 🛠️ TIMEZONE FIX: If finish_time is empty, we use current local time
//           if (d.finish_time && d.finish_time.includes(' ')) {
//             endPart = d.finish_time.split(' ')[1].substring(0, 5);
//           } else {
//             // This ensures the modal shows YOUR clock time (e.g., 20:09) instead of 18:09
//             endPart = dayjs().format("HH:mm");
//           }

//           // If datePart is still empty (new task), set to today
//           if (!datePart) datePart = dayjs().format("YYYY-MM-DD");

//           setFormData({
//             title: d.title || "",
//             appointment_date: datePart,
//             appointment_start: startPart || dayjs().format("HH:mm"),
//             appointment_end: endPart,
//           });
//           setLoading(false);
//         })
//         .catch((err) => {
//           console.error("Fetch error:", err);
//           setLoading(false);
//         });
//     }
//   }, [open, id]);

//   const handleSaveOrClose = () => {
//     const cleanId = String(id).replace('issue-', '').split(':')[0];
    
//     // 🛠️ FIX: Reconstruct the string to keep your local Cyprus time
//     const localFinish = `${dayjs(formData.appointment_date).format("DD-MM-YYYY")} ${formData.appointment_end}`;
//     const localReported = `${dayjs(formData.appointment_date).format("DD-MM-YYYY")} ${formData.appointment_start}`;

//     console.log("SENDING TO DB:", localFinish);

//     const payload = {
//       title: formData.title,
//       reported: localReported,
//       finish_time: localFinish,
//       status: "closed"
//     };

//     axiosClient.patch(`/api/issues/${cleanId}/`, payload)
//       .then(() => {
//         refresh();
//         handleClose();
//       })
//       .catch(err => {
//         alert("Update failed. Check console.");
//       });
//   };

//   const darkInput = {
//     '& .MuiOutlinedInput-root': { color: 'white', '& fieldset': { borderColor: '#777' } },
//     '& .MuiInputLabel-root': { color: '#aaa' },
//     '& .MuiInputBase-input': { color: 'white' }
//   };

//   return (
//     <Dialog open={open} onClose={handleClose} fullWidth maxWidth="xs" PaperProps={{ sx: { bgcolor: '#1e1e1e', color: 'white' } }}>
//       <DialogTitle sx={{ fontWeight: 'bold' }}>COMPLETE TASK</DialogTitle>
      
//       <DialogContent dividers sx={{ borderColor: '#333' }}>
//         {loading ? (
//           <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}><CircularProgress color="inherit" /></Box>
//         ) : (
//           <Stack spacing={3} sx={{ mt: 1 }}>
//             <TextField 
//               fullWidth label="TASK NAME" 
//               value={formData.title} 
//               InputProps={{ readOnly: true }}
//               sx={darkInput} 
//             />
            
//             <TextField 
//               fullWidth label="DATE" type="date" 
//               value={formData.appointment_date} 
//               InputLabelProps={{ shrink: true }} 
//               onChange={(e) => setFormData({...formData, appointment_date: e.target.value})}
//               sx={darkInput} 
//             />
            
//             <Stack direction="row" spacing={2}>
//               <TextField 
//                 fullWidth label="START TIME" type="time" 
//                 value={formData.appointment_start} 
//                 InputLabelProps={{ shrink: true }} 
//                 sx={darkInput} 
//               />
//               <TextField 
//                 fullWidth label="END TIME" type="time" 
//                 value={formData.appointment_end} 
//                 InputLabelProps={{ shrink: true }} 
//                 onChange={(e) => setFormData({...formData, appointment_end: e.target.value})}
//                 sx={darkInput} 
//               />
//             </Stack>
//           </Stack>
//         )}
//       </DialogContent>
      
//       <DialogActions sx={{ p: 2 }}>
//         <Button onClick={handleClose} sx={{ color: '#90caf9' }}>CANCEL</Button>
//         <Button variant="contained" color="success" onClick={handleSaveOrClose} sx={{ fontWeight: 'bold' }}>
//           SUBMIT & CLOSE
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// };

// export default AppointmentEditModal;


////////////////////////////

// import React, { useState, useEffect } from "react";
// import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Stack, CircularProgress, Box } from "@mui/material";
// import axiosClient from "../axiosClient";
// import dayjs from "dayjs";

// const AppointmentEditModal = ({ open, id, handleClose, refresh }) => {
//   const [loading, setLoading] = useState(false);
//   const [formData, setFormData] = useState({ title: "", appointment_date: "", appointment_start: "", appointment_end: "" });

//   useEffect(() => {
//     if (open && id) {
//       setLoading(true);
//       const cleanId = String(id).replace('issue-', '').split(':')[0];
      
//       axiosClient.get(`/api/issues/${cleanId}/`)
//         .then((res) => {
//           const d = res.data;
//           let datePart = ""; let startPart = ""; let endPart = "";

//           // 🛠️ FIX EMPTY BOXES: Convert DD-MM-YYYY to YYYY-MM-DD
//           if (d.reported && d.reported.includes(' ')) {
//             const parts = d.reported.split(' ');
//             const bits = parts[0].split('-');
//             if (bits.length === 3) datePart = `${bits[2]}-${bits[1]}-${bits[0]}`;
//             startPart = parts[1].substring(0, 5);
//           }

//           // 🛠️ FIX TIME: Default to your REAL clock time (not UTC)
//           endPart = d.finish_time ? d.finish_time.split(' ')[1].substring(0, 5) : dayjs().format("HH:mm");

//           setFormData({
//             title: d.title || "",
//             appointment_date: datePart || dayjs().format("YYYY-MM-DD"),
//             appointment_start: startPart,
//             appointment_end: endPart,
//           });
//           setLoading(false);
//         })
//         .catch(() => setLoading(false));
//     }
//   }, [open, id]);

//   const handleSave = () => {
//     const cleanId = String(id).replace('issue-', '').split(':')[0];
    
//     // 🛠️ SEND HARD STRING: Reconstruct the format for the DB as text
//     const payload = {
//       title: formData.title,
//       reported: `${dayjs(formData.appointment_date).format("DD-MM-YYYY")} ${formData.appointment_start}`,
//       finish_time: `${dayjs(formData.appointment_date).format("DD-MM-YYYY")} ${formData.appointment_end}`,
//       status: "closed"
//     };

//     axiosClient.patch(`/api/issues/${cleanId}/`, payload)
//       .then(() => { refresh(); handleClose(); })
//       .catch(err => alert("Update failed"));
//   };

//   const darkInput = { '& .MuiOutlinedInput-root': { color: 'white', '& fieldset': { borderColor: '#777' } }, '& .MuiInputLabel-root': { color: '#aaa' } };

//   return (
//     <Dialog open={open} onClose={handleClose} fullWidth maxWidth="xs" PaperProps={{ sx: { bgcolor: '#1e1e1e', color: 'white' } }}>
//       <DialogTitle sx={{ fontWeight: 'bold' }}>COMPLETE TASK</DialogTitle>
//       <DialogContent dividers sx={{ borderColor: '#333' }}>
//         {loading ? <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}><CircularProgress color="inherit" /></Box> : (
//           <Stack spacing={3} sx={{ mt: 1 }}>
//             <TextField fullWidth label="TASK NAME" value={formData.title} InputProps={{ readOnly: true }} sx={darkInput} />
//             <TextField fullWidth label="DATE" type="date" value={formData.appointment_date} InputLabelProps={{ shrink: true }} 
//               onChange={(e) => setFormData({...formData, appointment_date: e.target.value})} sx={darkInput} />
//             <Stack direction="row" spacing={2}>
//               <TextField fullWidth label="START TIME" type="time" value={formData.appointment_start} InputLabelProps={{ shrink: true }} sx={darkInput} />
//               <TextField fullWidth label="END TIME" type="time" value={formData.appointment_end} InputLabelProps={{ shrink: true }} 
//                 onChange={(e) => setFormData({...formData, appointment_end: e.target.value})} sx={darkInput} />
//             </Stack>
//           </Stack>
//         )}
//       </DialogContent>
//       <DialogActions sx={{ p: 2 }}>
//         <Button onClick={handleClose} sx={{ color: '#90caf9' }}>CANCEL</Button>
//         <Button variant="contained" color="success" onClick={handleSave} sx={{ fontWeight: 'bold' }}>SUBMIT & CLOSE</Button>
//       </DialogActions>
//     </Dialog>
//   );
// };

// export default AppointmentEditModal;

// import React, { useState, useEffect } from "react";
// import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Stack, CircularProgress, Box } from "@mui/material";
// import axiosClient from "../axiosClient";
// import dayjs from "dayjs";

// const AppointmentEditModal = ({ open, id, handleClose, refresh }) => {
//   const [loading, setLoading] = useState(false);
//   const [formData, setFormData] = useState({ title: "", appointment_date: "", appointment_start: "", appointment_end: "" });

//   useEffect(() => {
//     if (open && id) {
//       setLoading(true);
//       const cleanId = String(id).replace('issue-', '').split(':')[0];
      
//       axiosClient.get(`/api/issues/${cleanId}/`)
//         .then((res) => {
//           const d = res.data;
//           console.log("--- MODAL DATA LOADED ---", d);

//           let datePart = ""; let startPart = ""; let endPart = "";

//           // 🛠️ REORDER DATE: Converts DD-MM-YYYY to YYYY-MM-DD
//           if (d.reported && d.reported.includes(' ')) {
//             const parts = d.reported.split(' ');
//             const bits = parts[0].split('-'); 
//             if (bits.length === 3) datePart = `${bits[2]}-${bits[1]}-${bits[0]}`;
//             startPart = parts[1].substring(0, 5);
//           }

//           // 🛠️ DEFAULT TIME: Use current PC time if end_time is empty
//           endPart = d.finish_time ? d.finish_time.split(' ')[1].substring(0, 5) : dayjs().format("HH:mm");

//           console.log("DEBUG: Parsed Date:", datePart, "Start:", startPart, "End:", endPart);

//           setFormData({
//             title: d.title || "",
//             appointment_date: datePart || dayjs().format("YYYY-MM-DD"),
//             appointment_start: startPart || dayjs().format("HH:mm"),
//             appointment_end: endPart,
//           });
//           setLoading(false);
//         })
//         .catch(() => setLoading(false));
//     }
//   }, [open, id]);

//   const handleSave = () => {
//     const cleanId = String(id).replace('issue-', '').split(':')[0];
    
//     // 🛠️ RECONSTRUCT: Format back to DD-MM-YYYY for the Database
//     const finalReported = `${dayjs(formData.appointment_date).format("DD-MM-YYYY")} ${formData.appointment_start}`;
//     const finalFinish = `${dayjs(formData.appointment_date).format("DD-MM-YYYY")} ${formData.appointment_end}`;

//     console.log("--- SENDING PATCH PAYLOAD ---");
//     console.log("Reported:", finalReported);
//     console.log("Finish:", finalFinish);

//     const payload = {
//       title: formData.title,
//       reported: finalReported,
//       finish_time: finalFinish,
//       status: "closed"
//     };

//     axiosClient.patch(`/api/issues/${cleanId}/`, payload)
//       .then(() => { refresh(); handleClose(); })
//       .catch(err => console.error("Update error:", err));
//   };

//   const darkInput = { '& .MuiOutlinedInput-root': { color: 'white', '& fieldset': { borderColor: '#777' } }, '& .MuiInputLabel-root': { color: '#aaa' } };

//   return (
//     <Dialog open={open} onClose={handleClose} fullWidth maxWidth="xs" PaperProps={{ sx: { bgcolor: '#1e1e1e', color: 'white' } }}>
//       <DialogTitle sx={{ fontWeight: 'bold' }}>COMPLETE TASK</DialogTitle>
//       <DialogContent dividers sx={{ borderColor: '#333' }}>
//         {loading ? <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}><CircularProgress color="inherit" /></Box> : (
//           <Stack spacing={3} sx={{ mt: 1 }}>
//             <TextField fullWidth label="TASK NAME" value={formData.title} InputProps={{ readOnly: true }} sx={darkInput} />
//             <TextField fullWidth label="DATE" type="date" value={formData.appointment_date} InputLabelProps={{ shrink: true }} 
//               onChange={(e) => setFormData({...formData, appointment_date: e.target.value})} sx={darkInput} />
//             <Stack direction="row" spacing={2}>
//               <TextField fullWidth label="START" type="time" value={formData.appointment_start} InputLabelProps={{ shrink: true }} sx={darkInput} />
//               <TextField fullWidth label="END" type="time" value={formData.appointment_end} InputLabelProps={{ shrink: true }} 
//                 onChange={(e) => setFormData({...formData, appointment_end: e.target.value})} sx={darkInput} />
//             </Stack>
//           </Stack>
//         )}
//       </DialogContent>
//       <DialogActions sx={{ p: 2 }}>
//         <Button onClick={handleClose} sx={{ color: '#90caf9' }}>CANCEL</Button>
//         <Button variant="contained" color="success" onClick={handleSave} sx={{ fontWeight: 'bold' }}>SUBMIT & CLOSE</Button>
//       </DialogActions>
//     </Dialog>
//   );
// };

// export default AppointmentEditModal;



/////////////////////////////

// import React, { useState, useEffect, useRef } from "react";
// import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Stack, CircularProgress, Box } from "@mui/material";
// import axiosClient from "../axiosClient";
// import dayjs from "dayjs";

// const AppointmentEditModal = ({ open, id, handleClose, refresh }) => {
//   const [loading, setLoading] = useState(false);
//   const [taskTitle, setTaskTitle] = useState("");
//   // 🛠️ THIS IS THE KEY: A Ref does not have "timezone logic" like State does
//   const timeInputRef = useRef(null); 

//   useEffect(() => {
//     if (open && id) {
//       setLoading(true);
//       const cleanId = String(id).replace('issue-', '').split(':')[0];
      
//       axiosClient.get(`/api/issues/${cleanId}/`)
//         .then((res) => {
//           setTaskTitle(res.data.title || "");
//           setLoading(false);
//         })
//         .catch(() => setLoading(false));
//     }
//   }, [open, id]);

//   const handleSave = () => {
//     const cleanId = String(id).replace('issue-', '').split(':')[0];
    
//     // 🛠️ GRAB THE RAW TEXT: This pulls exactly what is typed in the box
//     const exactTextFromBox = timeInputRef.current.value;

//     // This will prove to you that it sees 22:47
//     window.alert("SENDING THIS EXACT TEXT: " + exactTextFromBox);

//     axiosClient.patch(`/api/issues/${cleanId}/`, {
//       finish_time: exactTextFromBox,
//       status: "closed"
//     })
//     .then(() => {
//       refresh();
//       handleClose();
//     })
//     .catch((err) => alert("Error: " + err.message));
//   };

//   const inputStyle = { 
//     '& .MuiOutlinedInput-root': { color: 'white', '& fieldset': { borderColor: '#777' } }, 
//     '& .MuiInputLabel-root': { color: '#aaa' } 
//   };

//   return (
//     <Dialog open={open} onClose={handleClose} fullWidth maxWidth="xs" PaperProps={{ sx: { bgcolor: '#1e1e1e', color: 'white' } }}>
//       <DialogTitle sx={{ fontWeight: 'bold' }}>Complete Task</DialogTitle>
//       <DialogContent dividers sx={{ borderColor: '#333' }}>
//         {loading ? <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}><CircularProgress /></Box> : (
//           <Stack spacing={3} sx={{ mt: 1 }}>
//             <TextField fullWidth label="Task" value={taskTitle} InputProps={{ readOnly: true }} sx={inputStyle} />
            
//             {/* 🛠️ BYPASSING THE STATE ERROR: 
//                 1. No "value={...}"
//                 2. Use "defaultValue" to set the initial text
//                 3. Use "inputRef" to read the final text
//             */}
//             <TextField 
//               fullWidth 
//               label="End Date & Time" 
//               inputRef={timeInputRef}
//               defaultValue={dayjs().format("DD/MM/YYYY HH:mm")} 
//               sx={inputStyle}
//               helperText="Format: DD/MM/YYYY HH:mm"
//             />

//             <TextField fullWidth label="Comments" multiline rows={3} sx={inputStyle} />
//           </Stack>
//         )}
//       </DialogContent>
//       <DialogActions sx={{ p: 2 }}>
//         <Button onClick={handleClose} sx={{ color: '#90caf9' }}>CANCEL</Button>
//         <Button variant="contained" color="success" onClick={handleSave} sx={{ fontWeight: 'bold' }}>SUBMIT & CLOSE</Button>
//       </DialogActions>
//     </Dialog>
//   );
// };

// export default AppointmentEditModal;


// import React, { useState, useEffect } from "react";
// import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Stack, CircularProgress, Box } from "@mui/material";
// import axiosClient from "../axiosClient";

// const getLocalNow = () => {
//   const now = new Date();
//   const pad = (n) => String(n).padStart(2, "0");
//   return `${pad(now.getDate())}/${pad(now.getMonth() + 1)}/${now.getFullYear()} ${pad(now.getHours())}:${pad(now.getMinutes())}`;
// };

// const AppointmentEditModal = ({ open, id, handleClose, refresh }) => {
//   const [loading, setLoading] = useState(false);
//   const [taskTitle, setTaskTitle] = useState("");
//   const [comments, setComments] = useState("");
//   const [finishTime, setFinishTime] = useState(getLocalNow);

//   useEffect(() => {
//     if (open && id) {
//       setLoading(true);
//       setFinishTime(getLocalNow());
//       setComments("");

//       const cleanId = String(id).replace("issue-", "").split(":")[0];
//       axiosClient
//         .get(`/api/issues/${cleanId}/`)
//         .then((res) => {
//           setTaskTitle(res.data.title || "");
//           setLoading(false);
//         })
//         .catch(() => setLoading(false));
//     }
//   }, [open, id]);

//   const handleSave = () => {
//     const cleanId = String(id).replace("issue-", "").split(":")[0];

//     axiosClient
//       .patch(`/api/issues/${cleanId}/`, {
//         finish_time: finishTime,
//         comments,
//         status: "closed",
//       })
//       .then(() => {
//         refresh();
//         handleClose();
//       })
//       .catch((err) => alert("Error: " + err.message));
//   };

//   const inputStyle = {
//     "& .MuiOutlinedInput-root": {
//       color: "white",
//       "& fieldset": { borderColor: "#777" },
//       "&:hover fieldset": { borderColor: "#aaa" },
//       "&.Mui-focused fieldset": { borderColor: "#90caf9" },
//     },
//     "& .MuiInputLabel-root": { color: "#aaa" },
//     "& .MuiInputLabel-root.Mui-focused": { color: "#90caf9" },
//     "& .MuiFormHelperText-root": { color: "#777" },
//   };

//   return (
//     <Dialog
//       open={open}
//       onClose={handleClose}
//       fullWidth
//       maxWidth="xs"
//       PaperProps={{ sx: { bgcolor: "#1e1e1e", color: "white" } }}
//     >
//       <DialogTitle sx={{ fontWeight: "bold" }}>Complete Task</DialogTitle>
//       <DialogContent dividers sx={{ borderColor: "#333" }}>
//         {loading ? (
//           <Box sx={{ display: "flex", justifyContent: "center", p: 3 }}>
//             <CircularProgress />
//           </Box>
//         ) : (
//           <Stack spacing={3} sx={{ mt: 1 }}>
//             <TextField
//               fullWidth
//               label="Task"
//               value={taskTitle}
//               InputProps={{ readOnly: true }}
//               sx={inputStyle}
//             />

//             <TextField
//               fullWidth
//               label="End Date & Time"
//               value={finishTime}
//               onChange={(e) => setFinishTime(e.target.value)}
//               sx={inputStyle}
//               helperText="Format: DD/MM/YYYY HH:mm"
//             />

//             <TextField
//               fullWidth
//               label="Comments"
//               multiline
//               rows={3}
//               value={comments}
//               onChange={(e) => setComments(e.target.value)}
//               sx={inputStyle}
//             />
//           </Stack>
//         )}
//       </DialogContent>
//       <DialogActions sx={{ p: 2 }}>
//         <Button onClick={handleClose} sx={{ color: "#90caf9" }}>
//           CANCEL
//         </Button>
//         <Button
//           variant="contained"
//           color="success"
//           onClick={handleSave}
//           sx={{ fontWeight: "bold" }}
//         >
//           SUBMIT & CLOSE
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// };

// export default AppointmentEditModal;


////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// import React, { useState, useEffect } from "react";
// import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Stack, CircularProgress, Box } from "@mui/material";
// import axiosClient from "../axiosClient";

// const getLocalNow = () => {
//   const now = new Date();
//   const pad = (n) => String(n).padStart(2, "0");
//   return `${pad(now.getDate())}/${pad(now.getMonth() + 1)}/${now.getFullYear()} ${pad(now.getHours())}:${pad(now.getMinutes())}`;
// };

// const parseLocalToNaiveIso = (ddmmyyyyHHmm) => {
//   try {
//     const [datePart, timePart] = ddmmyyyyHHmm.trim().split(" ");
//     const [day, month, year] = datePart.split("/");
//     const [hours, minutes] = timePart.split(":");
//     const pad = (n) => String(n).padStart(2, "0");
//     return `${year}-${pad(month)}-${pad(day)}T${pad(hours)}:${pad(minutes)}:00`;
//   } catch {
//     return null;
//   }
// };

// const AppointmentEditModal = ({ open, id, handleClose, refresh }) => {
//   const [loading, setLoading] = useState(false);
//   const [taskTitle, setTaskTitle] = useState("");
//   const [comments, setComments] = useState("");
//   const [finishTime, setFinishTime] = useState(getLocalNow);

//   useEffect(() => {
//     if (open && id) {
//       setLoading(true);
//       setFinishTime(getLocalNow());
//       setComments("");

//       const cleanId = String(id).replace("issue-", "").split(":")[0];
//       axiosClient
//         .get(`/api/issues/${cleanId}/`)
//         .then((res) => {
//           setTaskTitle(res.data.title || "");
//           setLoading(false);
//         })
//         .catch(() => setLoading(false));
//     }
//   }, [open, id]);

//   const handleSave = () => {
//     const cleanId = String(id).replace("issue-", "").split(":")[0];

//     // Convert "16/03/2026 22:58" → "2026-03-16T22:58:00"
//     // No timezone conversion — Django stores it exactly as typed
//     const naiveIso = parseLocalToNaiveIso(finishTime);

//     if (!naiveIso) {
//       alert("Invalid date format. Please use DD/MM/YYYY HH:mm");
//       return;
//     }

//     axiosClient
//       .patch(`/api/issues/${cleanId}/`, {
//         scheduled_end: naiveIso,  // maps directly to model field
//         closed_at: naiveIso,      // maps directly to model field
//         staff_comment: comments,  // maps directly to model field
//         status: "closed",
//       })
//       .then(() => {
//         refresh();
//         handleClose();
//       })
//       .catch((err) => alert("Error: " + err.message));
//   };

//   const inputStyle = {
//     "& .MuiOutlinedInput-root": {
//       color: "white",
//       "& fieldset": { borderColor: "#777" },
//       "&:hover fieldset": { borderColor: "#aaa" },
//       "&.Mui-focused fieldset": { borderColor: "#90caf9" },
//     },
//     "& .MuiInputLabel-root": { color: "#aaa" },
//     "& .MuiInputLabel-root.Mui-focused": { color: "#90caf9" },
//     "& .MuiFormHelperText-root": { color: "#777" },
//   };

//   return (
//     <Dialog
//       open={open}
//       onClose={handleClose}
//       fullWidth
//       maxWidth="xs"
//       PaperProps={{ sx: { bgcolor: "#1e1e1e", color: "white" } }}
//     >
//       <DialogTitle sx={{ fontWeight: "bold" }}>Complete Task</DialogTitle>
//       <DialogContent dividers sx={{ borderColor: "#333" }}>
//         {loading ? (
//           <Box sx={{ display: "flex", justifyContent: "center", p: 3 }}>
//             <CircularProgress />
//           </Box>
//         ) : (
//           <Stack spacing={3} sx={{ mt: 1 }}>
//             <TextField
//               fullWidth
//               label="Task"
//               value={taskTitle}
//               InputProps={{ readOnly: true }}
//               sx={inputStyle}
//             />

//             <TextField
//               fullWidth
//               label="End Date & Time"
//               value={finishTime}
//               onChange={(e) => setFinishTime(e.target.value)}
//               sx={inputStyle}
//               helperText="Format: DD/MM/YYYY HH:mm"
//             />

//             <TextField
//               fullWidth
//               label="Comments"
//               multiline
//               rows={3}
//               value={comments}
//               onChange={(e) => setComments(e.target.value)}
//               sx={inputStyle}
//             />
//           </Stack>
//         )}
//       </DialogContent>
//       <DialogActions sx={{ p: 2 }}>
//         <Button onClick={handleClose} sx={{ color: "#90caf9" }}>
//           CANCEL
//         </Button>
//         <Button
//           variant="contained"
//           color="success"
//           onClick={handleSave}
//           sx={{ fontWeight: "bold" }}
//         >
//           SUBMIT & CLOSE
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// };

// export default AppointmentEditModal;


// ////////////////////////////////////////////////////////////////////////////////////////////////////////////////


import React, { useState, useEffect } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Stack, CircularProgress, Box } from "@mui/material";
import axiosClient from "../axiosClient";

const getLocalNow = () => {
  const now = new Date();
  const pad = (n) => String(n).padStart(2, "0");
  return `${pad(now.getDate())}/${pad(now.getMonth() + 1)}/${now.getFullYear()} ${pad(now.getHours())}:${pad(now.getMinutes())}`;
};

const parseLocalToNaiveIso = (ddmmyyyyHHmm) => {
  try {
    const [datePart, timePart] = ddmmyyyyHHmm.trim().split(" ");
    const [day, month, year] = datePart.split("/");
    const [hours, minutes] = timePart.split(":");
    const pad = (n) => String(n).padStart(2, "0");
    return `${year}-${pad(month)}-${pad(day)}T${pad(hours)}:${pad(minutes)}:00`;
  } catch {
    return null;
  }
};

const AppointmentEditModal = ({ open, id, handleClose, refresh }) => {
  const [loading, setLoading] = useState(false);
  const [taskTitle, setTaskTitle] = useState("");
  const [comments, setComments] = useState("");
  const [finishTime, setFinishTime] = useState(getLocalNow);

  useEffect(() => {
    if (open && id) {
      setLoading(true);
      setFinishTime(getLocalNow());
      setComments("");

      const cleanId = String(id).replace("issue-", "").split(":")[0];
  //     // axiosClient
  //       // .get('/api/issues/${cleanId}/')
  //       // ✅ RIGHT: Use backticks and NO "api/" prefix
  //     axiosClient.get(`issues/${id}/`);
  //        then((res) => {
  //         setTaskTitle(res.data.title || "");
  //         setLoading(false);
  //       })
  //       .catch(() => setLoading(false));
  //   }
  // }, [open, id]);
          axiosClient.get(`issues/${cleanId}/`)
                .then((res) => {
                  setTaskTitle(res.data.title || "");
                  setLoading(false);
                })
                .catch(() => setLoading(false));
            }
          }, [open, id]);


  const handleSave = () => {
    const cleanId = String(id).replace("issue-", "").split(":")[0];

    const naiveIso = parseLocalToNaiveIso(finishTime);

    if (!naiveIso) {
      alert("Invalid date format. Please use DD/MM/YYYY HH:mm");
      return;
    }

    // ✅ Use same endpoint & method as the technician path (POST to close-issue)
    // axiosClient
    //   .post('/api/close-issue/${cleanId}/', {
    //     end_time: naiveIso,
    //     comment: comments,
    //   })
    //   .then(() => {
    //     refresh();
    //     handleClose();
    //   })
      //  .catch((err) => alert("Error: " + (err.response?.data?.error || err.message)));
      axiosClient
      .post(`close-issue/${cleanId}/`, {
        end_time: naiveIso,
        comment: comments,
      })
      .then(() => {
        refresh();
        handleClose();
      })
      .catch((err) => alert("Error: " + (err.response?.data?.error || err.message)));
  };

  const inputStyle = {
    "& .MuiOutlinedInput-root": {
      color: "white",
      "& fieldset": { borderColor: "#777" },
      "&:hover fieldset": { borderColor: "#aaa" },
      "&.Mui-focused fieldset": { borderColor: "#90caf9" },
    },
    "& .MuiInputLabel-root": { color: "#aaa" },
    "& .MuiInputLabel-root.Mui-focused": { color: "#90caf9" },
    "& .MuiFormHelperText-root": { color: "#777" },
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="xs"
      PaperProps={{ sx: { bgcolor: "#1e1e1e", color: "white" } }}
    >
      <DialogTitle sx={{ fontWeight: "bold" }}>Complete Task</DialogTitle>
      <DialogContent dividers sx={{ borderColor: "#333" }}>
        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", p: 3 }}>
            <CircularProgress />
          </Box>
        ) : (
          <Stack spacing={3} sx={{ mt: 1 }}>
            <TextField
              fullWidth
              label="Task"
              value={taskTitle}
              InputProps={{ readOnly: true }}
              sx={inputStyle}
            />

            <TextField
              fullWidth
              label="End Date & Time"
              value={finishTime}
              onChange={(e) => setFinishTime(e.target.value)}
              sx={inputStyle}
              helperText="Format: DD/MM/YYYY HH:mm"
            />

            <TextField
              fullWidth
              label="Comments"
              multiline
              rows={3}
              value={comments}
              onChange={(e) => setComments(e.target.value)}
              sx={inputStyle}
            />
          </Stack>
        )}
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={handleClose} sx={{ color: "#90caf9" }}>
          CANCEL
        </Button>
        <Button
          variant="contained"
          color="success"
          onClick={handleSave}
          sx={{ fontWeight: "bold" }}
        >
          SUBMIT & CLOSE
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AppointmentEditModal;
